<!-- Label -->
<span class="select-search__label" [class.select-search__label--floating]="labelFloats">{{ placeholder }}</span>

<!-- Value -->
<input
    #searchInput
    *ngIf="open; else valueText"
    class="select-search__input"
    type="text"
    autocomplete="off"
    [placeholder]="selectedText"
    [value]="searchText"
    [attr.aria-activedescendant]="activeItemId"
    (input)="searchText = searchInput.value"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.preventDefault()"
>
<ng-template #valueText>
    <span class="select-search__value">{{ selectedText }}</span>
</ng-template>

<!-- Arrow -->
<svg class="select-search__arrow" viewBox="0 0 10 10" aria-hidden="true">
    <path d="M1 3l4 4 4-4"></path>
</svg>

<!-- Items -->
<ng-template #panel>
    <div
        class="select-search__panel"
        role="listbox"
        [attr.aria-multiselectable]="multiple || null"
        (mousedown)="$event.preventDefault()"
    >
        <ng-content select="app-select-item"></ng-content>
        <div *ngIf="noMatches" class="select-search__empty">No results found</div>
    </div>
</ng-template>
